import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/healthcare/HealthcareClient.tsx");
